import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { makePriceLabelRoundAE } from '../../../utils/helpers/make-price-label';

const InspectionCardHeader = ({ auction, isMyCarsSection }) => {
    const { year, make, model, variant, lastHighestBid } = auction || {};
    const title = `${year} ${make} ${model} - ${variant}`;

    const handleScrollTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    };

    return (
        <Paper elevation={0} className={`${isMyCarsSection ? 'bg-success' : ' bg-card-background'} h-36 w-full fixed top-0 left-0 right-0 z-10`}>
            <Stack className='px-6 pt-3 text-white ' direction={'row'} spacing={2}>
                <ArrowUpwardIcon onClick={handleScrollTop} />
                <Stack direction={'column'} spacing={-1}>
                    <Typography gutterBottom variant='body1' className='text-white pb-2 text-base uppercase'>
                        {title}
                    </Typography>
                    <Typography className='text-lg text-white'>
                        {makePriceLabelRoundAE(lastHighestBid)}
                    </Typography>
                </Stack>
            </Stack>
        </Paper>
    );
};
InspectionCardHeader.propTypes = {
    auction: PropTypes.object,
    isMyCarsSection: PropTypes.bool
};

export default InspectionCardHeader;
